import React from "react";
import { touchBehavior, type TouchState, type TouchThreshold } from "touch-behavior";
import type MailSwipeAction from "owa-service/lib/contract/MailSwipeAction";
import type Message from "owa-service/lib/contract/Message";
import { getSwipeRightAction, getSwipeLeftAction } from "owa-mail-list-swipe-utils";
import { getSwipeHandler } from "owa-mail-list-item-shared";
import type { MailListItemPartProps } from "owa-mail-list-item-shared";
import getItemForMailList from "owa-mail-store/lib/selectors/getItemForMailList";
import { TOUCH_THRESHOLD } from "../utils/constants";
import { logSwipeAction, skipHandleTouchCallback } from "../utils/helpers";
import { SwipeInProgressPlaceholder } from "./SwipeInProgressPlaceholder";

export default function mailListItemPartTouchBehavior(MailListItemPartComponent: React.FC<MailListItemPartProps>): React.ComponentClass<MailListItemPartProps> {
    return touchBehavior<MailListItemPartProps>({
        Component: MailListItemPartComponent,
        originalLeftSwipeRenderer: swipeRenderer(true /*isSwipeRight*/), // Left swipe renderer in TouchBehavior is a "Swipe from left" action
        originalRightSwipeRenderer: swipeRenderer(false /*isSwipeRight*/), // Right swipe renderer in TouchBehavior is a "Swipe from right" action
        originalGetLeftSwipeAction: getLeftSwipeAction,
        originalGetRightSwipeAction: getRightSwipeAction,
        skipHandleTouchCallback,
        threshold: TOUCH_THRESHOLD,
        shouldHandleRTLScenario: false,
        renderStaticSwipeRenderer: true,
    });
}

const getLeftSwipeAction = () => (props: MailListItemPartProps) => {
    const swipeAction = getSwipeRightAction(); // The getLeftSwipeAction callback in TouchBehavior is really "Swipe from left"
    const { nodeId, tableViewId } = props;
    
    if (swipeAction !== 0) {
        logSwipeAction(true /*isSwipeRight*/, swipeAction, nodeId, tableViewId, true /*isItemPart*/);
        getSwipeHandler(swipeAction, true /*isItemPart*/)?.(tableViewId, nodeId, "Swipe");
    }
};

const getRightSwipeAction = () => (props: MailListItemPartProps) => {
    const swipeAction = getSwipeLeftAction(); // The getRightSwipeAction callback in TouchBehavior is really "Swipe from right"
    const { nodeId, tableViewId } = props;
    
    if (swipeAction !== 0) {
        logSwipeAction(false /*isSwipeRight*/, swipeAction, nodeId, tableViewId, true /*isItemPart*/);
        getSwipeHandler(swipeAction, true /*isItemPart*/)?.(tableViewId, nodeId, "Swipe");
    }
};

const swipeRenderer = (isSwipeRight: boolean) => (props: MailListItemPartProps, state: TouchState, threshold: TouchThreshold) => {
    const { nodeId, isFirstLevelExpansion } = props;
    
    const item: Message | null | undefined = getItemForMailList(nodeId, isFirstLevelExpansion);
    const isUnread = item?.IsRead === false;
    
    return (<SwipeInProgressPlaceholder isSwipeRight={isSwipeRight} state={state} threshold={threshold} isUnread={isUnread}/>);
};
